export const BarListTranslationJP = {
  BarListTranslationFeature: {
    Text: {
      title: 'バー案内一覧',
      no_image: '画像無し',
    },
    Button: {
      add_new: '新規追加',
      detail: '詳細',
      delete: '削除',
      restore: '復元',
      target_menu: '対象メニュー一覧',
      change: '変更',
      save: '保存',
      close: '閉じる',
    },
    Table: {
      select: '選択',
      bar_guide_code: 'コード',
      bar_guide_name: 'ご案内名',
      bar_guide_type: 'タイプ',
      remark: '備考',
      target_menu: '対象メニュー',
    },
    DialogConfirm: {
      btn_cancel: 'キャンセル',
      btn_save: 'OK',
      title: '確認',
      message_delete:
        '選択されたバー案内を削除します。また、関連する自動生成したバー案内も同時に削除します。<br/>よろしいですか？',
      message_restore:
        '選択されたバー案内を復元します。また、関連する自動生成したバー案内が存在する場合、同時に復元します。<br/>よろしいですか？',
    },
    Toast: {
      success: '成功',
      error: 'エラー',
    },
    Modal: {
      information_name: 'ご案内名',
      title: 'タイトル',
      information_text: 'ご案内文',
      image: '画像',
      bar_information_detail: 'バー案内詳細',
      japanese: '日本語',
      english: '英語',
      simplified_chinese: '中国語(簡体字)',
      traditional_chinese: '中国語(繫体字)',
      korean: '韓国語',
      vietnamese: 'ベトナム語',
      remarks: '備考',
      notice_text: '※タイトル、ご案内文は、日本語以外の言語を選択し、その言語が未設定<br/>の場合、英語が表示されます。',
    },
  },
};
